import React from 'react';
import Css from './Sun.module.css'

export default function Sun() {
  return <>
         <span className={`${Css.sun}`}></span>
  </>;
}
